import { Component, OnInit } from "@angular/core";
import { NavController, NavParams } from "ionic-angular";
import { Observable } from 'rxjs/Rx';

import "rxjs/add/operator/mergeMap";

import { UpdateService } from '../../app/core/update.service';
import { TabsPage } from '../tabs/tabs';

@Component({
  selector: 'page-update',
  templateUrl: 'update.html'
})
export class UpdatePage implements OnInit {
  manualUpdate: boolean;
  status: string = 'ready';

  constructor(private navCtrl: NavController,
              private navParams: NavParams,
              private updateService: UpdateService) {
  }

  ngOnInit():void {
    this.manualUpdate = this.navParams.get('manualUpdate');
    this.updateService.resetProgress();

    if(this.manualUpdate) {
      this.update();
    }
  }

  update() {
    this.status = 'in progress';
    this.updateService.clearData().flatMap(
      () => this.updateService.getData(0)
    ).catch(error => {
      if (!navigator.onLine){
        console.error('Pas connecté à internet');
      }
      else{
        const errorJSON = JSON.parse(error.text());
        const errorMessage = errorJSON.message;
        switch (errorMessage) {
          case "Internal Server Error":
            console.error('Manque de priviléges dans la base de données/Base de données vide');
            break;
          default:
            console.error('Pas de connexion avec le serveur (back)')
        }
      }
      this.status = 'failed';
      return Observable.throw(error) || 'Server error';
    }).subscribe(() => this.status = 'complete');
  }

  backToBT() {
    this.navCtrl.push(TabsPage)
  }
}



// WEBPACK FOOTER //
// ./src/pages/update/update.ts